"use client";

import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ChevronDown, LogOut, Settings } from "lucide-react";
import { CURRENT_USER } from "@/lib/mock-data";

/** Global Shell primitive: current user / role display. */
export function UserMenu() {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className="flex items-center gap-2 rounded-control border border-border-subtle bg-surface-primary py-1.5 ps-1.5 pe-2.5 shadow-[var(--shadow-subtle)] hover:bg-surface-secondary"
        >
          <span
            className="flex h-8 w-8 items-center justify-center rounded-control bg-[linear-gradient(135deg,var(--color-accent-premium),var(--color-brand-primary))] text-xs font-bold text-white"
            aria-hidden="true"
          >
            {CURRENT_USER.initials}
          </span>
          <span className="hidden text-start sm:block">
            <span className="block text-xs font-bold text-text-primary">{CURRENT_USER.name}</span>
            <span className="block text-[10px] text-text-secondary">{CURRENT_USER.role}</span>
          </span>
          <ChevronDown aria-hidden="true" size={14} className="hidden text-text-secondary sm:block" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className="z-50 w-56 rounded-card border border-border-subtle bg-surface-elevated p-1.5 shadow-[var(--shadow-lifted)]"
        >
          <DropdownMenu.Item className="flex cursor-pointer items-center gap-2 rounded-control px-2.5 py-2 text-sm text-text-primary outline-none data-[highlighted]:bg-surface-secondary">
            <Settings aria-hidden="true" size={14} />
            Settings
          </DropdownMenu.Item>
          <DropdownMenu.Separator className="my-1 h-px bg-border-subtle" />
          <DropdownMenu.Item className="flex cursor-pointer items-center gap-2 rounded-control px-2.5 py-2 text-sm text-status-danger outline-none data-[highlighted]:bg-status-danger-bg">
            <LogOut aria-hidden="true" size={14} />
            Sign out
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
